import { captureException } from './error';

export async function getGeoCode(placeId) {
  await waitUntil(() => window.google?.maps, 20 * 1000);
  const { Geocoder } = await window.google.maps.importLibrary('geocoding');
  const geocoder = new Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode(
      { placeId },
      (responses, status) => {
        if (status === 'OK') {
          const lat = responses[0].geometry.location.lat();
          const lng = responses[0].geometry.location.lng();
          resolve({ lat, lng });
          return;
        }
        reject(new Error(status));
        captureException(new Error(JSON.stringify({ status, responses })));
      },
    );
  });
}

export async function reverseGeoCode(latLng) {
  await waitUntil(() => window.google?.maps, 20 * 1000);
  const { Geocoder } = await window.google.maps.importLibrary('geocoding');
  const geocoder = new Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode(
      { location: latLng },
      (results, status) => {
        if (status === 'OK') {
          const address = results.find((r) => r.types.includes('street_address')) ||
            results.find((r) => r.types.includes('premise')) ||
            results[0];
          resolve({
            text: address.formatted_address,
            inaccurate: !address.types.includes('street_address'),
          });
        } else {
          reject(new Error(status));
          captureException(new Error(JSON.stringify({ status, results })));
        }
      },
    );
  });
}

async function waitUntil(condition, time = 10 * 1000) {
  const start = Date.now();
  return new Promise((resolve, reject) => {
    check();

    function check() {
      if (condition()) {
        resolve();
        return;
      }
      if (Date.now() - start > time) {
        reject(new Error(`Loading Timeout ${condition}`));
        return;
      }
      setTimeout(check, 500);
    }
  });
}
